import React from 'react'

export default function Footer() {
  return (
     <footer className="footer">
               <div className="container-fluid">
                  <div className="row">
                     <div className="col-md-6">
                        <script>document.write(new Date().getFullYear())</script> © Pranathi Software Services Pvt. Ltd., All Rights Reserved.
                     </div>
                      
                  </div>
               </div>
            </footer>
  )
}
